import React from 'react';
import ReactDOM from 'react-dom';

import './static/css/style.css';

import Main from './Main';
import Header from './components/Header';
import Footer from './components/Footer';
import Guesser from './components/games/Guesser';

import CookiePolicy from './components/CookiePolicy';
import PrivacyPolicy from './components/PrivacyPolicy';
import Terms from './components/Terms';
import Contact from './components/Contact';
import Statistics from './components/Statistics';
import Riddles from './components/Riddles';

import './i18n';
import { useTranslation } from 'react-i18next';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import ReactGA from 'react-ga4';
ReactGA.initialize('G-4J51X44PYF');


function Root() {

	const languages = ["en"];
    const games = [];

	var url = window.location.href;

	if(!url.includes("www") && url.includes("guessie")) {
		var newUrl = url;
		newUrl = newUrl.replace("guessie", "www.guessie");
		if(url != newUrl) {

			window.location.href = newUrl;
		}
	}

	return (
		<>
			<Header/>
			<Router>
				<div className="App">
	            <Routes>
	                    <Route path="/" element={<Main lang="en" />} />

	                    <Route path="/cookies" element={<CookiePolicy />} />
	                    <Route path="/privacy" element={<PrivacyPolicy />} />
	                    <Route path="/terms" element={<Terms />} />
	                    <Route path="/contact" element={<Contact />} />

				        {languages.map(lang => (
				                <>
					                <Route
					                    path={`/${lang}/guess`}
					                    element={<Guesser lang={lang}  />}
					                />
					                <Route key={lang} path={`/${lang}/statistics`} element={<Statistics lang={lang} />}  />
					                <Route key={lang} path={`/${lang}/riddles`} element={<Riddles lang={lang} />}  />

				                </>
				            )
				        )}

	                    <Route path="/*" element={<Main lang="en" />} />
	            </Routes>


            </div>
			</Router>
			<Footer/>

		</>

	);
};


ReactDOM.render(<Root />, document.getElementById('root'));
const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(<Root />, rootElement);
} else {
  ReactDOM.render(<Root />, rootElement);
}
